<div class="video-container">
    <video [id]="elementId" class="video-js vjs-default-skin {{elementId+'-dimensions'}}" controls preload="auto">
    </video>
</div>